import { motion } from "framer-motion";
import React, { ReactNode } from "react";

type RouteTransitionProps = {
  children: ReactNode;
};

const RouteTransition: React.FunctionComponent<RouteTransitionProps> = ({
  children,
}: RouteTransitionProps) => {
  return (
    <motion.div
      className="flex-grow z-10"
      key="form"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.08 }}
    >
      {children}
    </motion.div>
  );
};

export default RouteTransition;
